export default __webpack_public_path__ + "static/media/Plumber.mama.83e16960.png";